<template>
  <el-dialog :visible.sync="dialogVisible" title="价格设置" width="80%" append-to-body>
    <div class="dialog-content">
      <vxe-toolbar v-if="!isDisabled">
        <template v-slot:buttons>
          <vxe-button type="primary" class="vxe-btn-primary" @click="insertEvent">新增</vxe-button>
          <vxe-button
            type="primary"
            class="vxe-btn-delete"
            @click="handleDelete"
            :style="'background-color:' + '#FE8783' + ';border:1px solid ' + '#FE8783'"
            >删除最后一条</vxe-button
          >
        </template>
      </vxe-toolbar>
      <vxe-table
        width="100%"
        align="left"
        show-header-overflow
        class="vxe-table-element"
        show-footer
        :auto-resize="true"
        border
        resizable
        show-overflow
        :data="tableData"
        :edit-config="!isDisabled ? { trigger: 'click', mode: 'row' } : {}"
        ref="priceTable"
        :max-height="400"
        :edit-rules="rules"
      >
        <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
        <vxe-table-column
          field="leaseDateFrom"
          title="计费开始时间"
          :edit-render="{
            name: 'default',
          }"
        >
          <template v-slot:edit="scope">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="scope.row.leaseDateFrom"
              type="date"
              placeholder="选择计费开始时间"
              disabled
            >
            </el-date-picker>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="leaseDateUntil"
          title="计费结束时间"
          :edit-render="{
            name: 'default',
          }"
        >
          <template v-slot:edit="scope">
            <el-date-picker
              value-format="yyyy-MM-dd"
              v-model="scope.row.leaseDateUntil"
              type="date"
              placeholder="选择计费结束时间"
              :picker-options="scope.row.pickerOptions"
            >
            </el-date-picker>
          </template>
          <template v-slot="{ row }"
            ><span>{{ row.leaseDateUntil }}</span></template
          >
        </vxe-table-column>
        <vxe-table-column
          field="chargeUnitPrice"
          title="计费单价"
          :edit-render="{ type: 'default' }"
        >
          <template v-slot:edit="scope">
            <inputNumber
              v-model="scope.row.chargeUnitPrice"
              :controls="false"
              class="inputWidth"
              :precision="3"
              :min="1"
              :max="999999999999999"
              @input="changePrice('chargeUnitPrice', scope.row)"
            ></inputNumber>
          </template>
        </vxe-table-column>
        <vxe-table-column field="chargePrice" title="计费金额" :edit-render="{ type: 'default' }">
          <template v-slot:edit="scope">
            <inputNumber
              v-model="scope.row.chargePrice"
              :controls="false"
              class="inputWidth"
              :precision="3"
              :min="1"
              :max="999999999999999"
              @input="changePrice('chargePrice', scope.row)"
            ></inputNumber>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <span slot="footer" class="dialog-footer" v-if="!isDisabled">
      <el-button @click="cancelhandle">取消</el-button>
      <el-button @click="submithandle" type="primary">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import moment from 'moment';

  export default {
    name: 'PriceSetDialog',
    props: {
      // 是否禁用
      isDisabled: {
        type: Boolean,
        default: false,
      },
      startDate: {
        type: String,
        default: () => '',
      },
      endDate: {
        type: String,
        default: () => '',
      },
      isShowPriceList: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialogVisible: false,
        tableData: [],
        rules: {
          leaseDateFrom: [{ required: true, message: '请选择' }],
          leaseDateUntil: [{ required: true, message: '请选择' }],
          chargeUnitPrice: [{ required: true, message: '请选择' }],
          chargePrice: [{ required: true, message: '请选择' }],
        },
        isEditModal: false,
        rowItem: null,
        priceType: '', //判断是空间价格设置还是物业费价格设置
      };
    },
    methods: {
      changePrice(prop, row) {
        if (prop == 'chargeUnitPrice') {
          if (this.rowItem?.chargeMethod === '01') {
            row.chargePrice = (
              Number(this.rowItem?.spaceArea) * Number(row.chargeUnitPrice)
            ).toFixed(3);
          } else {
            row.chargePrice = Number(row.chargeUnitPrice).toFixed(3);
          }
        }
        this.$nextTick(() => {
          this.$refs.priceTable.clearValidate();
        });
      },
      openModal(row, priceType) {
        this.rowItem = row;
        let rows = [];
        this.priceType = priceType;
        // 物业价格设置
        if (priceType == 'property') {
          rows = Object.assign(row.leaseContractPropertyDetails, []);
        } else {
          // 空间价格设置
          rows = Object.assign(row.spaceDetails, []);
        }
        if (!this.startDate.length || !this.endDate.length) {
          this.$message.error('请先选择租赁开始和租赁结束时间');
          return;
        }
        this.dialogVisible = true;
        if (rows.length) {
          rows = this.processOptions(rows);
          this.isEditModal = true;
          console.log(this.$route.query.type == 'renewal', '????');
          if (this.$route.query.type == 'renewal' && !this.isShowPriceList) {
            this.tableData = [];
          } else {
            this.tableData = Object.assign([], rows);
          }
        } else {
          this.isEditModal = false;
          this.tableData = [];
        }
      },
      handleDelete() {
        // const selectedList = this.$refs.priceTable.getSelectRecords(); // 或许选中数据
        // console.log(selectedList, '选中要删除的');
        // if (selectedList.length < 1) {
        //   this.$message({
        //     showClose: true,
        //     message: this.$t('goods.message.noChooseDel'),
        //     type: 'error',
        //   });
        //   return;
        // }
        // // vxe-table中删除方法
        // this.$refs.priceTable.removeSelecteds();

        let data = this.getTableData();

        if (data.length == 0) {
          this.$message.error('表格已经没有数据了，请添加');
          return;
        }
        data.splice(-1, 1);
        if (data.length > 0) {
          data[data.length - 1].leaseDateUntil = this.endDate;
        }
        this.tableData = data;

        this.$message({
          showClose: true,
          type: 'success',
          message: this.$t('goods.message.delSuccess'),
        });
      },
      getNextDefaultData() {
        let prev = {};
        let next = {};
        if (this.tableData.length != 0) {
          prev = Array.from(this.tableData)[this.tableData.length - 1];
          if (Object.keys(prev).length != 0) {
            if (prev.leaseDateUntil == this.endDate) {
              //周期已经占完了，终止流程
              this.$message.error('已经选择完了所有日期对应的价格!');
              return null;
            }
            let nextStartDate = moment(prev.leaseDateUntil).add(1, 'days').format('YYYY-MM-DD');
            let nextEndDate = moment(this.endDate).format('YYYY-MM-DD');
            next = {
              leaseDateFrom: nextStartDate,
              leaseDateUntil: nextEndDate,
              chargePrice: '',
              chargeUnitPrice: '',
            };
          } else {
            return null;
          }
        } else {
          next = {
            leaseDateFrom: this.startDate,
            leaseDateUntil: this.endDate,
            chargePrice: '',
            chargeUnitPrice: '',
          };
        }
        next.pickerOptions = this.getRowPickerOption(next);
        return next;
      },
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.priceTable;
        return $table.getTableData().fullData;
      },
      //   插入
      insertEvent() {
        this.$refs['priceTable'].validate(async (valid) => {
          //         "spaceDetails": [
          //   {
          //     "chargePrice": 0,
          //     "chargeUnitPrice": 0,
          //     "companyCode": "string",
          //     "companyName": "string",
          //     "contractId": 0,
          //     "createBy": "string",
          //     "departmentCode": "string",
          //     "departmentCodes": [
          //       "string"
          //     ],
          //     "departmentName": "string",
          //     "gmtCreate": "2023-04-13T08:57:30.816Z",
          //     "gmtModified": "2023-04-13T08:57:30.816Z",
          //     "id": 0,
          //     "isDeleted": 0,
          //     "lastModifiedBy": "string",
          //     "leaseDateFrom": "2023-04-13T08:57:30.816Z",
          //     "leaseDateUntil": "2023-04-13T08:57:30.816Z",
          //     "sortNo": 0,
          //     "spaceId": 0,
          //     "tenantCode": "string",
          //     "version": 0
          //   }
          // ],
          if (valid) {
            let record = this.getNextDefaultData();
            if (record) {
              let row = await this.$refs.priceTable.insertAt(record, -1);
              this.$refs.priceTable.setActiveRow(row);
              this.tableData = this.getTableData();
            }
          } else {
            this.$message.error('请检查表格内容');
          }
        });
      },
      //   取消
      cancelhandle() {
        this.tableData = [];
        this.rowItem = null;
        this.dialogVisible = false;
      },
      //   提交
      submithandle() {
        this.tableData = this.getTableData();
        this.$refs['priceTable'].validate(async (valid) => {
          if (!this.checkTimeInvervalValid()) {
            return;
          }
          if (valid) {
            let details = Object.assign([], this.tableData);
            let res = {};
            if (this.priceType == 'property') {
              res = { ...this.rowItem, leaseContractPropertyDetails: details };
            } else {
              // 空间价格设置
              res = { ...this.rowItem, spaceDetails: details };
            }
            this.$emit('submit', res);
            this.cancelhandle();
          } else {
            this.$message.error('请检查表格内容');
          }
        });
      },
      checkTimeInvervalValid() {
        let array = Array.from(this.tableData);
        if (array.length == 0) {
          this.$message.error('请填写表格数据再提交');
          return false;
        }
        // let duration = 0;
        // let expectedDuration = Date.parse(this.endDate) - Date.parse(this.startDate);
        // array.forEach((item) => {
        //   let actualEndDate=moment(item.leaseDateUntil).add(1, 'days').format('YYYY-MM-DD');
        //   duration += Date.parse(actualEndDate) - Date.parse(item.leaseDateFrom);
        // });

        let totalStartDate = array[0].leaseDateFrom;
        if (totalStartDate != this.startDate) {
          this.$message.error('所选开始日期和租赁开始日期不一致');
          return false;
        }
        let totalEndDate = array[array.length - 1].leaseDateUntil;
        if (totalEndDate != this.endDate) {
          this.$message.error('所选结束日期和租赁结束日期不一致');
          return false;
        }

        // if (duration != expectedDuration) {
        //   this.$message.error('所选总时长和租赁期限总时长不一致');
        //   return false;
        // }

        return true;
      },
      getRowPickerOption(row) {
        return {
          disabledDate: (time) => {
            return time < new Date(row.leaseDateFrom) - 8.64e7 || time >= new Date(this.endDate);
          },
        };
      },
      processOptions(rows) {
        let res = rows.map((item) => {
          return { ...item, pickerOptions: this.getRowPickerOption(item) };
        });
        return res;
      },
    },
  };
</script>

<style></style>
